export interface LinkIconProps {
    className: string;
}

export function LinkIcon({className = ''}: LinkIconProps) {
    return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.82 16.82" className={`w-full ${className}`}>
        <path d="M9.87,12.62l-1.87,1.87c-.76.76-1.77,1.18-2.84,1.18s-2.08-.42-2.84-1.18-1.18-1.77-1.18-2.84.42-2.08,1.18-2.84l1.87-1.87c.22-.22.22-.59,0-.81-.22-.22-.59-.22-.81,0l-1.87,1.87c-.98.98-1.51,2.27-1.51,3.65s.54,2.68,1.51,3.65c.98.98,2.27,1.51,3.65,1.51s2.68-.54,3.65-1.51l1.87-1.87c.22-.22.22-.59,0-.81-.22-.22-.59-.22-.81,0Z"/>
        <path d="M15.31,1.51c-2.02-2.01-5.29-2.02-7.31,0l-1.87,1.87c-.22.22-.22.59,0,.81.22.22.59.22.81,0l1.87-1.87c1.57-1.57,4.12-1.57,5.68,0s1.57,4.11,0,5.68l-1.87,1.87c-.22.22-.22.59,0,.81.11.11.26.17.41.17s.29-.06.41-.17l1.87-1.87c.98-.98,1.51-2.27,1.51-3.65s-.54-2.68-1.51-3.65Z"/>
        <path d="M10.44,5.57l-4.87,4.87c-.22.22-.22.59,0,.81.11.11.26.17.41.17s.29-.06.41-.17l4.87-4.87c.22-.22.22-.59,0-.81-.22-.22-.59-.22-.81,0Z"/>
    </svg>
    )
}